import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.href ? 'a' : 'router-link'), _mergeProps(_ctx.href ? { href: _ctx.href, target: _ctx.target } : { to: _ctx.to }, {
    class: ["flex h-full items-center justify-center gap-x-1.5 border-t-2", [_ctx.active ? 'bg-white text-next-orange font-bold border-next-orange':'border-next-neu text-next-gray-md hover:text-white hover:border-next-dark-gray hover:bg-next-dark-gray duration-300']]
  }), {
    default: _withCtx(() => [
      _createElementVNode("i", {
        class: _normalizeClass(_ctx.iconClass)
      }, null, 2),
      _createElementVNode("span", null, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 16, ["class"]))
}